import React, { useEffect, useRef } from 'react';
import './Home.css';
import workingImg from "../Images/Laptop.png";
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import SEO from '../Components/SEO';
import { seoConfig } from '../config/seo.config';
import './../App.css';

const Home: React.FC = () => {
  const { language, t } = useLanguage();
  const heroImageRef = useRef<HTMLImageElement>(null);
  const logoRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const updateLogoSize = () => {
      if (heroImageRef.current && logoRef.current) {
        const imageWidth = heroImageRef.current.offsetWidth;
        const logoWidth = imageWidth * 0.35;
        logoRef.current.style.width = `${logoWidth}px`;
      }
    };

    updateLogoSize();
    window.addEventListener('resize', updateLogoSize);

    return () => {
      window.removeEventListener('resize', updateLogoSize);
    };
  }, []);

  return (
    <div className="home-container">
      <SEO
        title={seoConfig[language].home.title}
        description={seoConfig[language].home.description}
        keywords={seoConfig[language].home.keywords}
        path={`/${language}`}
      />
      {/* Section Image avec Logo superposé */}
      <section className="image-section">
        <img
          ref={heroImageRef}
          src={workingImg}
          alt="Personne travaillant sur un ordinateur portable"
          className="hero-image"
          loading="lazy"
        />
      </section>

      {/* Section Citation */}
      <section className="quote-section">
        <blockquote
          className="company-quote"
          dangerouslySetInnerHTML={{ __html: t('home.quote') as string }}
        />
      </section>

      {/* Section CTA */}
      <section className="cta-section-home">
        <p className="cta-text-home" dangerouslySetInnerHTML={{ __html: t('home.cta.text') as string }}/>
        <div className="cta-button-container">
          <Link to={`/${language}/contact`} className="cta-button">{t('home.cta.button')}</Link>
        </div>
        <p className="clients-text" dangerouslySetInnerHTML={{ __html: t('home.cta.clients') as string }}/>
      </section>
    </div>
  );
};

export default Home;
